import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

export interface Option {
  value: string;
  label: string;
}

@Component({
  selector: 'app-campana-select',
  standalone: true,
  imports: [FormsModule, NgSelectModule],
  templateUrl: './campana-select-component.html',
  styleUrls: ['./campana-select-component.scss'],
})
export class CampanaSelectComponent implements OnChanges {
  /** Opciones que se muestran en el dropdown */
  @Input() options: Option[] = [];

  /** Opción actualmente seleccionada */
  @Input() selected?: Option;

  /** Placeholder para el dropdown */
  @Input() placeholder: string = '';

  /** Emite la opción seleccionada al padre */
  @Output() selectionChange = new EventEmitter<Option>();

  @Input() compact = false;

  hasNoOptions = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.hasNoOptions = this.options.length === 0;
      if (this.hasNoOptions) {
        this.selected = undefined;
      }
    }
  }

  /** Manejar el cambio del ng-select */
  onChange(opt: Option) {
    this.selectionChange.emit(opt);
  }
}
